import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Button,
  Chip,
  Stack,
  Divider,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  AutoAwesome as AutoAwesomeIcon,
  Close as CloseIcon,
  Add as AddIcon
} from '@mui/icons-material';

const AiRuleSuggestionsCard = ({ ruleSuggestions, onCreateRule, onDismiss }) => {
  if (!ruleSuggestions?.length) return null;

  return (
    <Paper
      elevation={3}
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 3,
        mb: { xs: 2, sm: 4 },
        width: '100%',
        boxShadow: '0 4px 20px rgba(123, 31, 162, 0.08)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <AutoAwesomeIcon color="secondary" fontSize="small" />
        <Typography variant="h6" fontWeight="bold" sx={{ fontSize: { xs: '1rem', sm: '1.15rem' } }}>
          Suggested Rules
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Create these so matching transactions are categorized automatically next time, with no AI call needed.
      </Typography>

      <Stack divider={<Divider />} spacing={0}>
        {ruleSuggestions.map((rule) => (
          <Box
            key={`${rule.keyword}|${rule.categoryId}`}
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'stretch', sm: 'center' },
              justifyContent: 'space-between',
              gap: { xs: 1, sm: 2 },
              py: 1.5,
            }}
          >
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                <Typography variant="body2" color="text.secondary">
                  If description contains
                </Typography>
                <Chip label={rule.keyword} size="small" sx={{ fontSize: '0.8125rem', height: 22 }} />
                <Typography variant="body2" color="text.secondary">
                  →
                </Typography>
                <Chip
                  label={rule.categoryName}
                  size="small"
                  color="secondary"
                  variant="outlined"
                  sx={{ fontSize: '0.8125rem', height: 22 }}
                />
              </Box>
              <Typography
                variant="caption"
                color="text.secondary"
                noWrap
                sx={{ display: 'block', mt: 0.25, fontSize: '0.75rem' }}
              >
                e.g. {rule.exampleDescription}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                startIcon={<AddIcon />}
                onClick={() => onCreateRule(rule)}
                sx={{
                  borderRadius: 3,
                  textTransform: 'none',
                  fontWeight: 500,
                  flex: { xs: 1, sm: 'none' },
                }}
              >
                Create rule
              </Button>
              <Tooltip title="Dismiss">
                <IconButton size="small" onClick={() => onDismiss(rule)} sx={{ color: 'text.secondary' }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};

export default AiRuleSuggestionsCard;
